// extracted by mini-css-extract-plugin
export var legendIndicator = "_d0-1";
export var legendRight = "_d0-0";